import MainLayout from "screens/partials/layout";
import StorboltOrderListingComponent from "screens/partials/order-listing";

export default function Orders() {
    return (
        <MainLayout>
            <StorboltOrderListingComponent />
        </MainLayout>
    )
}